import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Metric } from 'types/engagement.types';
import { describeMetric, type Formatter } from './format';

/** A number or Metric; a missing value renders its status as text, never as 0 (see format.ts). */
interface MetricTextProps {
  value: number | Metric | null | undefined;
  format: Formatter;
  /** Show the reason as a second line instead of only in the tooltip. */
  showReason?: boolean;
  variant?: 'inline' | 'kpi';
}

export const MetricText: React.FC<MetricTextProps> = ({ value, format, showReason = false, variant = 'inline' }) => {
  const { t } = useTranslation();
  const d = describeMetric(value, format, t);
  if (d.hasValue) {
    return (
      <span data-metric-status={'ok'} style={variant === 'kpi' ? { fontSize: 26, fontWeight: 600 } : undefined}>
        {d.text}
      </span>
    );
  }
  const label = (
    <span
      data-metric-status={d.status}
      style={{
        color: d.status === 'failed' ? '#B42318' : '#707070',
        fontStyle: 'italic',
        fontSize: variant === 'kpi' ? 15 : undefined,
        fontWeight: variant === 'kpi' ? 500 : undefined,
      }}
    >
      {d.text}
    </span>
  );
  return (
    <>
      {d.reason ? <Tooltip title={d.reason}>{label}</Tooltip> : label}
      {showReason && d.reason ? (
        <Typography component={'span'} sx={{ display: 'block', fontSize: 12, color: 'text.secondary' }}>
          {d.reason}
        </Typography>
      ) : null}
    </>
  );
};
